<template>
  <div class="logout"></div>
</template>

<script>
import router from '@/router'
import store from '@/store'
import axios from '@/axios'

export default {
  async created () {
    try {
      await axios.post('/api/auth/logout')
      localStorage.removeItem('user')
      localStorage.removeItem('tokenExp')
      store.commit('LOGOUT_USER')
      router.push('/login')
    } catch (e) {
      console.error(e)
    }
  }
}
</script>